<img botAvatar alt="-" data-testid="bot-avatar" />
<fof-typing-indicator data-testid="bot-typing-indicator"></fof-typing-indicator>
